<template>
  <v-container mt-7>
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col class="selectorColumn">
          <v-select
            v-model="orgChoice"
            :items="organizations"
            label="Organizations"
            :disabled="orgDisabled"
            outlined
            dense
            clearable
            @click:clear="$nextTick(() => (orgChoice = null))"
          >
          </v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="insChoice"
            :items="insurances"
            label="Select Insurance"
            :disabled="insDisabled"
            outlined
            dense
            clearable
            required
            :rules="[() => !!insChoice || 'Please select an insurance']"
            @click:clear="$nextTick(() => (insChoice = null))"
          ></v-select>
        </v-col>
        <v-col v-if="selectedView === 'Reconciliation Summary'" class="selectorColumn">
          <v-select
            v-model="groupChoice"
            :items="groups"
            label="Groups"
            required
            :rules="[(groupChoice) => groupChoice.length !== 0 || 'Please select a Group']"
            :disabled="groupDisabled"
            :multiple="multipleGroups"
            outlined
            dense
            clearable
            @click:clear="$nextTick(() => (groupChoice = []))"
            class="newSelect"
          >
            <template v-slot:selection="{ item, index }">
              <div class="selection-text" v-if="index === 0">{{ item }}</div>
              <span v-if="index === 1" class="grey--text caption"
                >+{{ groupChoice.length - 1 }}</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col v-else class="selectorColumn">
          <v-select
            v-model="groupChoice"
            :items="groups"
            label="Groups"
            :disabled="groupDisabled"
            :multiple="multipleGroups"
            outlined
            dense
            clearable
            @click:clear="$nextTick(() => (groupChoice = []))"
            class="newSelect"
          >
            <template v-slot:selection="{ item, index }">
              <div class="selection-text" v-if="index === 0">{{ item }}</div>
              <span v-if="index === 1" class="grey--text caption"
                >+{{ groupChoice.length - 1 }}</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="provChoice"
            :items="providers"
            item-text="Provide_Name"
            return-object
            label="Providers"
            :disabled="provDisabled"
            multiple
            outlined
            dense
            clearable
            class="newSelect"
          >
            <template v-slot:selection="{ item, index }">
              <div class="selection-text" v-if="index === 0">{{ item.Provide_Name }}</div>
              <span v-if="index === 1" class="grey--text caption"
                >+{{ provChoice.length - 1 }}</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-select
            v-model="locChoice"
            :items="locations"
            item-text="Center_Location"
            return-object
            label="Locations"
            :disabled="locDisabled"
            multiple
            outlined
            dense
            clearable
            class="newSelect"
          >
            <template v-slot:selection="{ item, index }">
              <div class="selection-text" v-if="index === 0">{{ item }}</div>
              <span v-if="index === 1" class="grey--text caption">+{{ locChoice.length - 1 }}</span>
            </template>
          </v-select>
        </v-col>

        <v-col class="selectorColumn">
          <v-select
            v-model="selectedView"
            :items="visibleReports"
            label="Select a View"
            clearable
            outlined
            dense
            required
            :rules="[() => !!selectedView || 'Please select a View']"
            @click:clear="$nextTick(() => (selectedView = null))"
          ></v-select>
        </v-col>
        <v-col class="selectorColumn">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDate"
                label="Start Date"
                show-current="2018-01"
                append-icon="mdi-calendar"
                outlined
                dense
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="startDate"
              type="month"
              :max="endDate"
              show-current="false"
              @input="menu = false"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="selectorColumn">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDate"
                label="End Date"
                append-icon="mdi-calendar"
                outlined
                dense
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="endDate"
              :max="maxEndDate"
              show-current="false"
              type="month"
              @input="menu2 = false"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          v-if="
            selectedView === 'Service Fund' ||
            selectedView === 'Reconciliation' ||
            selectedView === 'Reconciliation Summary'
          "
          class="selectorColumn"
        >
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="PEDate"
                label="PE Date"
                append-icon="mdi-calendar"
                outlined
                dense
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="PEDate" type="month" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="selectorColumn">
          <v-btn
            :disabled="selectedView === 'MRA Simulator' ? true : false"
            @click="validate"
            color="secondary"
            depressed
            block
            class="py-5"
          >
            Run Report
            <v-icon>mdi-play</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row v-if="selectedView != 'MRA Simulator'">
      <v-col v-if="load" cols="12" class="text-center">
        <v-progress-circular
          color="secondary"
          indeterminate
          :size="50"
          :width="3"
        ></v-progress-circular>
      </v-col>

      <v-col
        v-else-if="(!insChoice || !selectedView) && !showReport"
        cols="12"
      >
        <v-alert :value="true" type="info"> Please select all required fields </v-alert>
      </v-col>
      <v-col v-else-if="(!!insChoice || !!selectedView) && !hasRun" cols="12">
        <v-alert :value="true" type="info"> Press run report to continue </v-alert>
      </v-col>
      <v-col v-else-if="showReport && changeDetected && hasRun" cols="12">
        <v-alert :value="true" type="warning">
          Change detected: Run the report to see updated data
        </v-alert>
      </v-col>
      <v-col v-else-if="financeReportHasNoRows && showReport && hasRun" cols="12">
        <v-alert :value="true" type="info">
          There is no data available for this selection. Please change your filter selections and
          run report again
        </v-alert>
      </v-col>
    </v-row>
    <FundingExpense
      v-if="this.selectedView == 'Service Fund'"
      :organization="orgChoice"
      :groups="groupNum"
      :providers="provChoice"
      :locations="locChoice"
      :insurance="insChoice"
      :startDate="startDate"
      :endDate="endDate"
      :data="reportData"
      :reportType="selectedView"
      @pmpm="pmpmReport"
    />
    <Reconciliation
      v-else-if="this.selectedView == 'Reconciliation'"
      :organization="orgChoice"
      :groups="groupNum"
      :insurance="insChoice"
      :startDate="startDate"
      :endDate="endDate"
      @newStartDate="setStartDate"
      @newEndDate="setEndDate"
      :reportData="reportData"
      @pmpm="pmpmReport"
    />
    <ReconciliationSummary
      v-else-if="this.selectedView == 'Reconciliation Summary'"
      :organization="orgChoice"
      :groups="groupNum"
      :insurance="insChoice"
      :startDate="startDate"
      :endDate="endDate"
      @newStartDate="setStartDate"
      @newEndDate="setEndDate"
      :reportData="reportData"
    />
    <Mlr
      v-if="this.selectedView == 'MLR'"
      :organization="orgChoice"
      :group="groupNum"
      :providers="provChoice"
      :locations="locChoice"
      :insurance="insChoice"
      :startDate="startDate"
      :endDate="endDate"
      :data="reportData"
    />
    <Mra
      v-if="this.selectedView == 'MRA'"
      :organization="orgChoice"
      :group="groupNum"
      :providers="provChoice"
      :locations="locChoice"
      :insurance="insChoice"
      :startDate="startDate"
      :endDate="endDate"
      :data="reportData"
    />
    <Simulator v-else-if="this.selectedView == 'MRA Simulator'" />
  </v-container>
</template>

<script>
import axios from 'axios';
import FundingExpense from '../components/financeComponents/FundingExpense';
import Reconciliation from '../components/financeComponents/Reconciliation';
import ReconciliationSummary from '../components/financeComponents/ReconciliationSummary';
import Mlr from '../components/financeComponents/mlr';
import Mra from '../components/financeComponents/mra';
import Simulator from '../components/financeComponents/Simulator';

export default {
  components: {
    FundingExpense,
    Reconciliation,
    ReconciliationSummary,
    Mlr,
    Mra,
    Simulator,
  },
  data() {
    return {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 3)
        .toISOString()
        .substr(0, 7),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1)
        .toISOString()
        .substr(0, 7),
      maxEndDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1)
        .toISOString()
        .substr(0, 7),
      menu: false,
      modal: false,
      menu2: false,
      tab: null,
      orgChoice: null,
      groupChoice: [],
      reconcilArrayCopy: [],
      provChoice: [],
      provNums: [],
      locChoice: [],
      insChoice: null,
      user: '',
      organizations: [],
      providers: [],
      groups: [],
      groupObject: [],
      groupNum: [],
      insurances: [],
      locations: [],
      selectedView: null,
      load: false,
      PEDate: new Date(new Date()).toISOString().substr(0, 7),
      reportData: [],
      pmpm: false,
      showReport: false,
      changeDetected: false,
      hasRun: false,
      cancelSource: null,
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    isOrgChoiceEmpty() {
      const o = this.orgChoice;
      if (o == null || o === '') return true;
      return Array.isArray(o) ? o.length === 0 : false;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.getReport();
      }
    },
    pmpmReport(e) {
      this.pmpm = e;
      this.getReport();
    },
    /** IDs de PCP para a URL (evita array vazio → `groups=/Humana`). */
    financeGroupsParam() {
      const raw = Array.isArray(this.groupNum) ? this.groupNum : this.groupNum != null ? [this.groupNum] : [];
      return raw
        .filter((id) => id != null && String(id).trim() !== '')
        .map((id) => String(id).trim())
        .join(',');
    },
    async syncGroupNumsFromSelection(cancelToken, namesOverride) {
      const names = namesOverride != null ? namesOverride : this.groupChoice;
      const hasNames = Array.isArray(names)
        ? names.length > 0
        : names != null && String(names).trim() !== '';
      if (!this.insChoice || !hasNames) {
        this.groupNum = [];
        return;
      }
      this.providers = [];
      this.provChoice = [];
      this.locations = [];
      this.locChoice = [];
      this.groupNum = [];
      const gc = Array.isArray(names)
        ? names.map((n) => encodeURIComponent(String(n))).join(',')
        : encodeURIComponent(String(names));
      const cfg = cancelToken ? { cancelToken } : {};
      const { data } = await axios.get(`api/selection/${this.insChoice}/group/${gc}`, cfg);
      this.groupObject = data || [];
      (data || []).forEach((element) => {
        if (this.user.role === 'Provider') {
          if (this.user.provider.includes(element.Provide_Name)) {
            this.providers.push(element);
            this.provChoice.push(element);
          }
        } else {
          this.providers.push(element);
        }
        if (this.insChoice && element.Center_PCP_Number != null && String(element.Center_PCP_Number).trim() !== '') {
          const s = String(element.Center_PCP_Number).trim();
          if (this.groupNum.indexOf(s) === -1) this.groupNum.push(s);
          if (/^\d+$/.test(s) && s.length > 1 && s.startsWith('0')) {
            const noLeading = s.replace(/^0+/, '') || '0';
            if (noLeading !== s && this.groupNum.indexOf(noLeading) === -1) {
              this.groupNum.push(noLeading);
            }
          }
        }
      });
    },
    async getReport() {
      this.reportData = [];
      this.hasRun = true;

      // This will grab the correct groupNums if no groups are selected. This is for a group level login when only select groups available to the user
      if (this.user.role === 'Group' && this.groupNum.length === 0) {
        this.cancelSource = axios.CancelToken.source();
        const groupNames =
          this.groupChoice && this.groupChoice.length > 0 ? this.groupChoice : this.groups;
        try {
          await this.syncGroupNumsFromSelection(this.cancelSource.token, groupNames);
        } catch (e) {
          if (!axios.isCancel(e)) {
            console.error('[Finance getReport Group preset]', e);
          }
        }
      }

      const needsGroupIds =
        this.selectedView === 'Reconciliation' || this.selectedView === 'Reconciliation Summary';
      if (needsGroupIds && this.groupChoice.length > 0 && this.financeGroupsParam() === '') {
        try {
          await this.syncGroupNumsFromSelection();
        } catch (e) {
          console.error('[Finance getReport sync groups]', e);
        }
      }

      const groupsParam = this.financeGroupsParam();
      if (needsGroupIds && this.groupChoice.length > 0 && groupsParam === '') {
        console.warn('[Finance] Grupos selecionados mas sem PCP IDs — selecione de novo ou aguarde a lista.');
        this.load = false;
        this.reportData = [];
        return;
      }

      let url = '';
      if (this.selectedView === 'Reconciliation') {
        url = `api/servicefund/reconciliation/${this.orgChoice}/groups=${groupsParam}/${this.insChoice}/${this.PEDate}/${this.startDate}/${this.endDate}/${this.pmpm}`;
      } else if (this.selectedView === 'Service Fund') {
        url = `api/fundandexp/groups=${this.groupNum}/providers=${this.provNums}/locations=${this.locChoice}/${this.insChoice}/${this.PEDate}/${this.startDate}/${this.endDate}/${this.pmpm}`;
      } else if (this.selectedView === 'Reconciliation Summary') {
        url = `api/servicefund/recsummary/${this.orgChoice}/groups=${groupsParam}/${this.insChoice}/${this.PEDate}/${this.startDate}/${this.endDate}/${this.pmpm}`;
      } else if (this.selectedView === 'MLR') {
        url = `api/mlr/group=${groupsParam || this.groupNum}/${this.insChoice}/provider=${this.provNums}/location=${this.locChoice}/start=${this.startDate}/end=${this.endDate}`;
      } else if (this.selectedView === 'MRA') {
        url = `api/mra/group=${groupsParam || this.groupNum}/${this.insChoice}/provider=${this.provNums}/location=${this.locChoice}/start=${this.startDate}/end=${this.endDate}`;
      }

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();

      this.load = true;
      this.reportData = [];

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();
      axios
        .get(url, { cancelToken: this.cancelSource.token })
        .then((response) => {
          this.showReport = true;
          this.reportData = response.data;
          this.cancelSource = null;
          this.load = false;
          this.changeDetected = false;
        })
        .catch((err) => {
          if (!axios.isCancel(err)) {
            console.error('Finance report failed:', err.response && err.response.status, url, err.message);
          }
          this.cancelSource = null;
          this.load = false;
          this.reportData = [];
        });
    },
    async checkPresets() {
      if (this.user.role === 'Provider' || this.user.role === 'Group') {
        this.setPresets();
      } else if (this.user.role === 'Clinical') {
        this.$router.push('/membership');
      } else {
        this.getOrgs();
        this.getInsurances();
      }
    },
    async setPresets() {
      if (this.user.role === 'Group') {
        this.organizations = [this.user.organization];
      } else {
        this.organizations = this.user.organization;
      }
      this.groups = this.user.group;
      this.insurances = this.user.insurance;

      if (this.user.role === 'Provider') {
        this.insChoice = Array.isArray(this.user.insurance) ? this.user.insurance[0] : this.user.insurance;
        this.orgChoice = this.user.organization;
        this.groupChoice = this.user.group;
        this.providers = this.user.provider;
        this.location = this.user.location;
      } else if (this.user.role === 'Group') {
        this.orgChoice = this.user.organization;
        this.insChoice = Array.isArray(this.user.insurance) ? this.user.insurance[0] : this.user.insurance;
      } else if (this.user.role === 'Clinical') {
        this.$router.push('/');
      }
    },
    async getUser() {
      await axios
        .get('/api/user')
        .then((response) => {
          this.user = response.data[0];
        })
        .catch((err) => this.$router.push('/login'));
      this.checkPresets();
    },
    async getOrgs() {
      // const response = await axios.get('api/list/organization').then((response) => {
      //   this.organizations = response.data;
      //   this.orgChoice = this.organizations[0];
      // });
      this.organizations = ['Clearspring', 'Humana'];
    },
    async getInsurances() {
      // const response = await axios.get('api/list/insurances').then((response) => {
      //   this.insurances = response.data;
      // });
      this.insurances = ['Clearspring', 'Humana'];
    },
    groupNameFromListItem(grp) {
      if (grp == null) return '';
      if (typeof grp === 'string') return grp;
      return grp.GROUP_NAME || grp.group_name || '';
    },
    normalizeGroupList(responseData) {
      const rows = Array.isArray(responseData) ? responseData : [];
      return rows
        .map((g) => this.groupNameFromListItem(g))
        .filter((name) => name && String(name).trim() !== '');
    },
    async getGroups() {
      if (!this.insChoice) {
        this.groups = [];
        return;
      }
      const insSlug = encodeURIComponent(String(this.insChoice));
      const r = this.user && this.user.role ? String(this.user.role).toLowerCase() : '';
      try {
        if (r === 'group' && this.insurances.length === 1) {
          this.groups = this.user.group;
          return;
        }
        if (r === 'group' && this.insurances.length > 1) {
          const response = await axios.get(`api/list/${insSlug}/groups`);
          const userObjGroups = this.user.group;
          const allPossibleGroups = this.normalizeGroupList(response.data);
          this.groups = [];
          allPossibleGroups.forEach((name) => {
            if (userObjGroups.indexOf(name) !== -1) {
              this.groups.push(name);
            }
          });
          return;
        }
        const response = await axios.get(`api/list/${insSlug}/groups`);
        this.groups = this.normalizeGroupList(response.data);
      } catch (e) {
        console.error('[Finance getGroups]', e);
        this.groups = [];
      }
    },
    async setStartDate(date) {
      this.startDate = date;
    },
    async setEndDate(date) {
      this.endDate = date;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },
  watch: {
    async orgChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
      if (!this.insChoice) {
        return;
      }
      await this.getGroups();
    },
    async locChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
    },
    async groupChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
      if (this.selectedView === 'Reconciliation') {
        this.reconcilArrayCopy[0] = this.groupChoice;
      }
      // Populates the group selector for group level logins with one insurance and one group available
      if (this.user.role === 'Group' && this.insurances.length === 1 && this.groups.length === 1) {
        this.groupChoice = this.user.group;
      }

      if (this.groupChoice.length > 0) {
        this.cancelSearch();
        this.cancelSource = axios.CancelToken.source();
        const token = this.cancelSource.token;
        try {
          await this.syncGroupNumsFromSelection(token);
        } catch (e) {
          if (!axios.isCancel(e)) {
            console.error('[Finance groupChoice]', e);
          }
        } finally {
          this.cancelSource = null;
        }
      } else {
        this.providers = [];
        this.provChoice = [];
        this.locChoice = [];
        this.locations = [];
        this.groupNum = [];
      }
    },
    async provChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
      if (this.provChoice !== []) {
        const prov = this.provChoice;
        let allProviders = this.providers;
        let providerNames = [];
        this.locations = [];
        this.locChoice = [];
        this.provNums = [];

        // Create an Array of selected provider names
        prov.forEach((provs) => {
          providerNames.push(provs.Provide_Name);
        });

        // Loop through all the providers objects and see if there is a match with any names in providerNames array
        allProviders.forEach((p) => {
          if (providerNames.indexOf(p.Provide_Name) !== -1) {
            this.provNums.push(p.Center_PCP_Number);
            // Add the location
            if (p.Center_Location !== null) {
              this.locations.push(p.Center_Location);
            } else {
              this.locations.push(p.Center_PCP_Number + '- No Location Provided');
            }
          }
        });
      } else {
        this.locChoice = [];
        this.locations = [];
      }
    },
    async insChoice() {
      if (this.showReport) {
        this.changeDetected = true;
      }
      this.groupChoice = [];
      this.provChoice = [];
      this.locChoice = [];

      const r = this.user && this.user.role ? String(this.user.role).toLowerCase() : '';

      if (r === 'provider') {
        this.insurances = this.user.insurance;
        this.groupChoice = this.user.group;
        return;
      }

      if (this.insChoice) {
        await this.getGroups();
      }
    },
    async selectedView() {
      this.pmpm = false;
      if (this.selectedView === 'Service Fund' && this.insChoice) {
        this.showReport = true;
      } else {
        this.showReport = false;
      }
      if (this.selectedView === 'Service Fund' || this.selectedView === 'MRA Simulator') {
        this.startDate = new Date(new Date().getFullYear(), new Date().getMonth() - 3)
          .toISOString()
          .substr(0, 7);

        this.endDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1)
          .toISOString()
          .substr(0, 7);
      }
      // Só Reconciliation (1 grupo) zera seleção; Summary é multi-grupo e não deve apagar os já escolhidos.
      if (this.selectedView === 'Reconciliation') {
        this.groupChoice = [];
        this.provChoice = [];
        this.locChoice = [];
      }
    },
    async startDate() {
      if (this.showReport === true) {
        this.changeDetected = true;
      }
    },
    async endDate() {
      if (this.showReport === true) {
        this.changeDetected = true;
      }
    },
    async PEDate() {
      this.changeDetected = true;
    },
    async multipleGroups() {
      if (
        this.multipleGroups === true &&
        this.reconcilArrayCopy.length > 0 &&
        this.selectedView === 'Reconciliation'
      ) {
        this.groupChoice = this.reconcilArrayCopy;
        this.reconcilArrayCopy = [];
      }
    },
  },
  computed: {
    /** Reconciliation Summary envia objeto { reconData, recSummary }; array vazio não bate com .length. */
    financeReportHasNoRows() {
      const d = this.reportData;
      if (d == null) return true;
      if (Array.isArray(d)) return d.length === 0;
      if (typeof d === 'object' && Object.prototype.hasOwnProperty.call(d, 'reconData')) {
        const r = d.reconData;
        return !Array.isArray(r) || r.length === 0;
      }
      return false;
    },
    visibleReports() {
      if (this.user.role === 'Provider') {
        return ['Service Fund', 'MLR', 'MRA', 'MRA Simulator'];
      } else {
        return [
          'Service Fund',
          'Reconciliation',
          'Reconciliation Summary',
          'MLR',
          'MRA',
          'MRA Simulator',
        ];
      }
    },
    orgDisabled() {
      if (this.user.role === 'Provider' || this.user.role === 'Group') {
        return true;
      }
      return false;
    },
    insDisabled() {
      if (this.user.role === 'Provider' || this.insurances.length == 1) {
        return true;
      }
      return false;
    },
    provDisabled() {
      if (this.groupChoice.length === 0) {
        return true;
      }
      if (this.user.role === 'Provider') {
        return true;
      }
      if (
        this.selectedView === 'Reconciliation' ||
        this.selectedView === 'Reconciliation Summary'
      ) {
        this.provChoice = [];
        return true;
      }
      return false;
    },
    locDisabled() {
      if (
        this.provChoice.length === 0 ||
        this.groupChoice.length === 0 ||
        this.insChoice === 'Humana'
      ) {
        return true;
      }
      return false;
    },
    groupDisabled() {
      // Igual KPIs: grupos vêm de api/list/:insurance/groups: não exigir organização
      // para não bloquear o select quando org ainda está vazia ou Humana+Humana.
      if (!this.insChoice) {
        return true;
      }
      const r = this.user && this.user.role ? String(this.user.role).toLowerCase() : '';
      if (r === 'provider') {
        return true;
      }
      if (r === 'group' && this.groups.length === 1) {
        this.groupChoice = this.user.group;
        return true;
      }
      return false;
    },
    multipleGroups() {
      return this.selectedView !== 'Reconciliation';
    },
  },
};
</script>
<style scoped>
.newSelect .v-select__selection {
  white-space: nowrap;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selection-text {
  margin-right: 5px;
}
@media only screen and (min-width: 1200px) {
  .selection-text {
    white-space: nowrap;
    overflow: hidden;
    width: 70%;
  }
}
</style>
